import React, { useState, useEffect, useRef } from "react";
import {
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  Image,
  Dimensions,
} from "react-native";
import "../../components/Tabs/react-tabs.css";
import { useNavigation } from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { FormattedMessage, useIntl } from "react-intl";
import CardsHome from "../../components/CardsHome";
import Header from "../../components/Header";
import ScreenLoader from "../../components/ScreenLoader";
import TokenReleases from "../../components/TokenReleases";
import { toast } from "../../utils/toast";
import api from "../../services/api";
import styles from "./styles";
import CardForestAdoption from "../../components/cardForestAdoption";
import HeaderTabs from "../../components/HeaderTabs";
import { When } from "react-if";
import useLocalTranslation from "../../i18n/hooks/useLocalTranslation";
import StampsCalculatorCard from "../../components/StampsCalculatorCard";

const Home = () => {
  const navigation = useNavigation();
  const [investorProfile, setInvestorProfile] = useState();
  const [level, setLevel] = useState();
  const [nameuser, setNameUser] = useState("");
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [clientCountry, setClientCountry] = useState(null);
  const intl = useIntl();
  const width = Dimensions.get("window").width;
  const isSmallScreen = width < 1300;

  useEffect(() => {
    getClientCountry();
    getDataUsers();
  }, []);

  const getClientCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country);
  };

  const getDataUsers = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading1(true);
    api
      .get(`/clients/getDetails/client`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        const username = res.data.name_user[0].name.toString();
        const level = res.data.user[0].client.level.toString();
        const userType = res.data.user[0].client.cnpj ? "PJ" : "PF";
        await AsyncStorage.setItem("usertype", userType);
        await AsyncStorage.setItem("level", level);
        await AsyncStorage.setItem("nameuser", username);
        setInvestorProfile(res.data.user[0].client.is_investor_profile);
        setLevel(res.data.user[0].client.level);
        setNameUser(username);
        setLoading1(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading1(false);
        toast(intl.formatMessage({ id: "home.mensagemErro" }), "#DA1414");
      });
  };

  function openInvestorProfile() {
    navigation.navigate("InvestorProfile");
  }
  if (clientCountry === null) {
    return <ScreenLoader loading={true} />;
  }

  return (
    <>
      <ScreenLoader loading={loading1 || loading2 || loading3} />
      <HeaderTabs
        title={
          <Text numberOfLines={3}>
            <FormattedMessage id="header.ola" />
            {nameuser}
          </Text>
        }
      />
      <ScrollView>
        <View style={styles.container}>
          <View
            style={[
              styles.secondContainer,
              { flexDirection: isSmallScreen ? "column" : "row" },
            ]}
          >
            <View style={styles.headerAndAdoptionContainer}>
              <View style={styles.headerContainer}>
                <Header loading={(value) => setLoading3(value)} />
              </View>
              <View style={styles.containerCardsHome}>
                <CardsHome />
              </View>
            </View>
            <View style={[styles.containerForestInvestor]}>
              <CardForestAdoption />
              <When condition={!investorProfile && level === 3}>
                <TouchableOpacity
                  onPress={openInvestorProfile}
                  style={styles.contentInvestorProfile}
                >
                  <Text style={styles.textInvestorProfile}>
                    <FormattedMessage id="home.criarPerfil" />
                  </Text>
                </TouchableOpacity>
              </When>
              <When condition={clientCountry === "brasil"}>
                <StampsCalculatorCard />
              </When>
            </View>
          </View>
          <Text style={styles.titleSugestao}>
            <FormattedMessage id="home.sugestaoAtivos" />
          </Text>
          <View style={styles.TokenReleasesContainer}>
            <TokenReleases loading={(value) => setLoading2(value)} />
          </View>
        </View>
      </ScrollView>
    </>
  );
};

export default Home;
